import { render } from "./MoreMenu.vue?vue&type=template&id=27c9d648&scoped=true"
import script from "./MoreMenu.vue?vue&type=script&lang=js"
export * from "./MoreMenu.vue?vue&type=script&lang=js"

import "./MoreMenu.vue?vue&type=style&index=0&id=27c9d648&scoped=true&lang=css"
import "./MoreMenu.vue?vue&type=style&index=1&id=27c9d648&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c9d648"]])

export default __exports__